/** URL prefix for everything served by the app, e.g. "/taxi/" in production. Always ends with a slash. */
export const BASE: string = (import.meta.env?.BASE_URL as string | undefined) ?? '/';
/** URL prefix for the generated assets (audio/, models/, levels/). Defaults to BASE; in development
 *  VITE_ASSET_BASE (.env.development) points it at the Toybox project's files URL. Always ends with a slash. */
export const ASSET_BASE: string = ((import.meta.env?.VITE_ASSET_BASE as string | undefined) || BASE).replace(/\/?$/, '/');

export const SIM_HZ = 60;
export const SIM_DT = 1 / SIM_HZ;

/** Vehicle glTF meshes face +Z in Babylon after import; flip if a model turns out backwards. */
export const VEHICLE_YAW_OFFSET = 0;
